<!--
  - Copyright (c) 2019. K+S France & Isagri Ingénierie
  - SD version du 03/06/2019 10:35
  - composant gérant la vue ph du sol
  -->

<template>
  <div class="ground">
    <h1 class="form-title">{{ $t('ground_title') }}</h1>

    <v-form v-model="validElements" ref="elements">
      <div class="contour">
        <v-layout row wrap align-center>
          <v-flex xs3>
            <div><img src="img/elem_k2o.svg"/></div>
          </v-flex>
          <v-flex xs9 class="slideElem">
            <v-slider
              v-model="k2o"
              always-dirty
              step="1"
              min="0"
              max="4"
              ticks="always"
              tick-size="2"
              thumb-size="65"
              :tick-labels="labelsElements"
              @change="groundChange"
            >
              <template v-slot:thumb-label="props">
                <span>
                  {{ labelElements(props.value) }}
                </span>
              </template>
            </v-slider>
          </v-flex>
        </v-layout>
        <v-layout row wrap align-center>
          <v-flex xs3>
            <div><img src="img/elem_mgo.svg"/></div>
          </v-flex>
          <v-flex xs9 class="slideElem">
            <v-slider
              v-model="mgo"
              always-dirty
              step="1"
              min="0"
              max="4"
              ticks="always"
              tick-size="2"
              thumb-size="70"
              :tick-labels="labelsElements"
              @change="groundChange"
            >
              <template v-slot:thumb-label="props">
                <span>
                  {{ labelElements(props.value) }}
                </span>
              </template>
            </v-slider>
          </v-flex>
        </v-layout>
      </div>
    </v-form> <!--elements-->
    <p>&nbsp;</p>
    <v-form v-model="validPh" ref="ph">
      <div class="contour">
        <v-layout row wrap align-center>
          <v-flex xs3>
            <p>{{ $t('ph_title') }}</p>
          </v-flex>
          <v-flex xs9 class="slideElem">
            <v-slider
              v-model="ph"
              always-dirty
              step="1"
              min="0"
              max="2"
              ticks="always"
              tick-size="2"
              :tick-labels="groundphLabels"
              @change="groundChange"
              class="small-labels"
            ></v-slider>
          </v-flex>
        </v-layout>
      </div>
    </v-form>
    <v-layout row nowrap justify-end>
      <v-btn color="primary" class="btn-ks white--text" @click="ground">{{
        $t("btn_next")
      }}</v-btn>
    </v-layout>
  </div>
  <!-- /.ground -->
</template>

<script>
export default {
  name: "Ground",
  data() {
    return {
      validElements: null,
      validPh: null,
      k2o: 2,
      mgo: 2,
      ph:1,
      labelsElements: []
    };
  },

  computed: {
    // groundLevelsList() {
    //   let labels = this.$store.getters.getGroundLevelsLabels;
    //   labels = labels.reverse();
    //   return labels;
    // },
    groundphLabels() {
      return this.$store.getters.getGroundPh;
    }
  },

  methods: {
    groundChange() {
      const gk2o = Math.abs(this.k2o - 4);
      const gmgo = Math.abs(this.mgo - 4);

      console.log(gk2o + " " + gmgo);

      const wealfObject = {
        wealf: {
          k2o: gk2o,
          mgo: gmgo
        },
        ph: this.ph
      };

      //console.log(wealfObject);

      this.$store.dispatch('storeGround', wealfObject);
    },
    ground() {
      this.groundChange();
      // this.$router.push({path: 'synthese'}); // on change de page

      this.$store.dispatch('updateRoutes', this.$router.currentRoute.path).then(
        () => {
          this.$router.push({path: 'synthese'}); // on change de page
        },
        () => {
          console.error("Erreud de routage ")
        }
      )
    },
    labelElements(val) {
      return this.labelsElements[val];
    }
  }, // methodes
  mounted() {
    this.labelsElements = this.$store.getters.getGroundLevelsLabels;

    if(this.$store.state.formulaire.ground.ph !== null) {
      this.k2o = Math.abs(this.$store.state.ref.sols.ground_levels.reduce((acc,val) => acc.concat(val[1]), []).indexOf(this.$store.state.formulaire.ground.wealf.k2o) - 4);
      this.mgo = Math.abs(this.$store.state.ref.sols.ground_levels.reduce((acc,val) => acc.concat(val[1]), []).indexOf(this.$store.state.formulaire.ground.wealf.mgo) - 4);
      this.ph = this.$store.state.formulaire.ground.ph;
    }
  }
}
</script>

<style lang="scss">
  .slideElem {
    padding-right: 1em;

    .v-slider__ticks > span {
      display: none;
    }
    .v-slider__ticks:first-child > span ,
    .v-slider__ticks:last-child > span  {
      display:block;
    }

    @media screen and (min-width: 480px) {
      padding-right: 4em;
    }

    @media screen and (min-width: 768px) {
      .v-slider__ticks > span {
        display:block;
      }
    }
  }

  .v-input.small-labels {
    .v-slider__ticks > span {
      font-size: 0.8em;
    }
  }

</style>
